import { useBusinessContext } from '@root/context'
import { useInfiniteQuery } from '@tanstack/react-query'
import { fetchAccountingRules } from '../accountingRules'

export const useInfiniteAccountingRules = () => {
  const { slug } = useBusinessContext()

  return useInfiniteQuery({
    queryKey: queryKeyForAccountingRules(slug),
    initialPageParam: 1,
    queryFn: ({ pageParam = 1 }) => fetchAccountingRules({ slug }, { page: pageParam }),
    getNextPageParam: lastPage => lastPage.next,
    getPreviousPageParam: lastPage => lastPage.prev,
    staleTime: 60 * 1000 // Stale time of 1 min in ms
  })
}

export const queryKeyForAccountingRules = (slug: string) => [slug, 'automationRules']
